/**
 * A dónde manda "ver detalle" de un curso. UNA sola definición para la landing y la app.
 *
 * Hay dos pantallas de detalle y cada una tiene una razón de existir:
 *
 *   - `/courses/:slug` es la ficha PÚBLICA. Se sirve con SSR real, JSON-LD y alternates en
 *     markdown: es la superficie que indexan Google y los agentes de IA, y la que se comparte
 *     en redes. Un anónimo tiene que caer acá.
 *   - `/course/:slug/details` es la pantalla DENTRO de la app. Sirve los cuatro estados del
 *     alumno (no adquirido / muestra / completo sin empezar / en curso) en una sola url.
 *     Alguien con sesión tiene que caer acá, porque es la única que sabe qué puede hacer.
 *
 * Antes cada sección de la home resolvía esto por su cuenta y no todas coincidían, así que el
 * mismo curso llevaba a pantallas distintas según desde qué bloque se lo tocara.
 */
export function resolveCourseDetailHref({
  slug,
  isLoggedIn,
  displayLanguage,
  webLanguage,
}: {
  slug: string;
  isLoggedIn: boolean;
  displayLanguage?: string;
  webLanguage?: string;
}): string {
  if (isLoggedIn) return `/course/${slug}/details`;

  // `?language` lo lee SÓLO la ficha pública, para servir la traducción pedida sin cambiar
  // el idioma de la sesión. Adentro de la app el idioma sale del perfil.
  return displayLanguage && displayLanguage !== webLanguage
    ? `/courses/${slug}?language=${displayLanguage}`
    : `/courses/${slug}`;
}

/**
 * A dónde manda el botón de inscripción directa (el que saltea carrito y checkout).
 *
 * La url es la MISMA para todos a propósito: es un contrato estable que la home puede
 * escribir en un `<a href>` estático sin saber si hay sesión. La pantalla del otro lado
 * decide qué mostrar — a quien ya está identificado le pide confirmación, y al anónimo lo
 * hace registrarse primero.
 */
export function resolveDirectEnrollHref({
  slug,
  previewOnly = false,
}: {
  slug: string;
  /** Pide la MUESTRA de un curso pago en vez del acceso completo. */
  previewOnly?: boolean;
}): string {
  const base = `/courses/${slug}/inscripcion`;
  return previewOnly ? `${base}?nivel=preview` : base;
}
